const endpoint = "/api/2024-10/graphql.json";
const accessToken = "0908071c83128b4cf2f201d74b5352c0";

const fetchAPI = async (query, variables) => {
  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken,
      },
      body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
      throw new Error();
    }

    const result = await response.json();

    return result;
  } catch (error) {
    return null;
  }
};

const formatVariantId = (variantGid) => {
  return variantGid.split("/").pop();
};

const formatMediaUrl = (mediaArray) => {
  return mediaArray.map((media) => media.image?.originalSrc);
};

const findProductHeroBanner = async (id) => {
  const query = `query getProductMetafields($id: ID!) {
    product(id: $id) {
      id
      title
      metafield(namespace: "custom", key: "hero_banner_gallery") {
        key
        value
        references(first: 10) {
          nodes {
            ... on MediaImage {
              image {
                originalSrc
              }
            }
          }
        }
      }
    }
  }`;

  const variables = { id: `gid://shopify/Product/${id}` };

  const response = await fetchAPI(query, variables);

  if (response.data && response.data?.product?.metafield?.references) {
    const mediaUrls = formatMediaUrl(
      response.data.product.metafield.references.nodes
    );

    return mediaUrls;
  }
};

const getProductVariants = async (productId) => {
  const query = `query getProductVariants($id: ID!) {
      product(id: $id) {
        id
        title
        variants(first: 100) {
          nodes {
            id
            sku
            title
          }
        }
      }
  }`;

  const variables = { id: `gid://shopify/Product/${productId}` };

  const response = await fetchAPI(query, variables);

  return response.data.product.variants.nodes;
};

const getSwatchGallery = async (sku, defaultHeroBannerImages) => {
  const query = `query MetaobjectByHandle($sku: String!) {
    metaobject(handle:{handle: $sku, type: "swatch_images"}) {
      id
      handle
      type
      fields {
        key
        value
        references(first: 10) {
          nodes {
            ... on MediaImage {
              image {
                originalSrc
              }
            }
          }
        }
      }
    }
  }
`;
  const variables = { sku };

  const response = await fetchAPI(query, variables);

  if (response.data && response?.data?.metaobject?.fields) {
    const medias = response.data.metaobject.fields.find(
      (item) => item.key == "images"
    );

    const mediaUrls = await formatMediaUrl(medias.references.nodes);

    return mediaUrls;
  }

  return defaultHeroBannerImages;
};
